import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";

import "./Room.css";
import ScrollToTop from "react-scroll-to-top";

import vinodniroom from "../images/Vinodini_room.jpg";
import vinodini from "../images/vinidini_room.jpg";
import Superdeluxeroom from "../images/Vinodini new.jpg";
import Superdeluxe from "../images/SupernDeluxeRoom.jpg";
import vinodiniroom from "../images/Vinodini_outside.jpg";
import vinodinidining from "../images/room_tv.jpg";


function Vinodini204() {

  return (
    <div>
      <Navbar />
      <br />
      <br />

      <br />
      <br />
      {/* <img src="" width="100%" alt="krishnanagar-hotel" /> */}
      <br />

      <ScrollToTop smooth top="100" color="darkgoldenrod" />
 
      <br />
      <center>
        <div className='fonts'>
          <div className='album py-0'>
            <div className='container'>
              <div className='veva'>
                <h1><b>RESERVATION FOR LUXURY ROOM</b></h1>
              </div>
            </div>
          </div>
        </div>
      </center>

      

      <div className='album py-0'>
        <div className='container'>
          <div className="row">
            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <div className='hoverimage1'>
                  <img src={vinodini} className="card-img-top image2" alt="vinodini_room" />
                  <div className="overlay1"> Super Deluxe Room</div>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <div className='hoverimage1'>
                  <img src={Superdeluxeroom} className="card-img-top image2" alt="Superdeluxeroom"/>
                  <div className="overlay1"> Super Deluxe Room</div>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <div className='hoverimage1'>
                  <img src={Superdeluxe} className="card-img-top image2" alt="vinodini_room" />
                  <div className="overlay1"> Super Deluxe Room</div>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <div className='hoverimage1'>
                  <img src={vinodiniroom} className="card-img-top image2" alt="vinodini_room" />
                  <div className="overlay1"> Super Deluxe Room</div>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <div className='hoverimage1'>
                  <img src={vinodini} className="card-img-top image2" alt="vinodini_room" />
                  <div className="overlay1"> Super Deluxe Room</div>
                </div>
              </div>
            </div>

            <div className="col-md-4 mt-3">
              <div className='homecard'>
                <div className='hoverimage1'>
                  <img src={vinodinidining} className="card-img-top image2" alt="vinodini_room" />
                  <div className="overlay1"> Super Deluxe Room</div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>


      {/* <Facility/> */}
      <br />
    </div>
  )
}

export default Vinodini204